import { orderBy } from "@progress/kendo-data-query";
//import { filterBy } from '@progress/kendo-data-query';
import moment from "moment";
import { saveExcel } from "@progress/kendo-vue-excel-export";
// import helpers from '../../shared/fleetbox-helpers';
import gridbase from "../../components/gridComponentBase.js";
import api from "../../services/api";
import cellTemplate from "../../components/grid/cellTemplate/cellTemplate.vue";
import { BNavbarBrand } from "bootstrap-vue";
import { mapGetters } from "vuex";

export default {
	extends: gridbase,
	components: {},
	data: function() {
		return {
			vehicleIdFilterField: "number_plate",
			dataReady: false,
			columns: [
				{
					field: "localization",
					title: "Localizza",
					configId: "",
					width: "100",
					headerCell: "myHeaderTemplate",
					cell: "myImageCellTemplate",
					editable: false,
					sortable: false,
					filterable: false,
					configByPass: true,
					order: 0
				},
				{
					field: "id",
					title: "id",
					configId: "id",
					width: "100",
					headerCell: "myHeaderTemplate",
					editable: false,
					filterable: false
				},
				{
					field: "vehicle_codes",
					title: "code",
					configId: "code",
					width: "150",
					headerCell: "myVehicleCodeHeaderTemplate",
					cell: "myCellTemplate",
					format: "link",
					editable: false,
					filterable: true
				},
				{
					field: "number_plate",
					title: "number plate",
					configId: "numberPlate",
					width: "100",
					format: "link",
					headerCell: "myVehicleNumberPlateHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "brand",
					title: "brand",
					configId: "vehicleBrandModel",
					width: "300",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "ownership_type",
					title: "ownership_type",
					configId: "ownershipTypeName",
					width: "170",
					headerCell: "myOwnershipTypesHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "ownership_supplier",
					title: "ownership_supplier",
					configId: "ownershipSupplierName",
					width: "200",
					headerCell: "myOwnershipSupliersHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "groups",
					title: "groups",
					configId: "groups",
					width: "200",
					headerCell: "myDriverGroupsHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "name",
					title: "name",
					configId: "name",
					width: "200",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "driver_surname_name",
					title: "Nome e cognome",
					configId: "driverSurnameName",
					width: "250",
					headerCell: "myDriverSurnameHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "driver_fiscal_code",
					title: "Codice Fiscale",
					configId: "driverFiscalCode",
					width: "250",
					headerCell: "myDriverCFHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "fuel_type",
					title: "fuel_type",
					configId: "fuelTypeName",
					width: "170",
					headerCell: "myFuelTypesHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "secondary_fuel_type",
					title: "secondary_fuel_type",
					configId: "secondaryFuelTypeName",
					width: "200",
					headerCell: "mySecondaryFuelTypesHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: false
				},
				{
					field: "tank_capacity",
					title: "tank_capacity",
					configId: "tankCapacity",
					width: "130",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					editable: false,
					filterable: true
				},
				{
					field: "category",
					title: "category",
					configId: "categoryName",
					width: "180",
					headerCell: "myCategoriesHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "car_sharing",
					title: "car_sharing",
					configId: "carSharing",
					width: "140",
					format: "boolean",
					className: "text-center",
					headerCell: "myBooleanHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "division",
					title: "division",
					configId: "divisionName",
					width: "120",
					headerCell: "myDivisionsHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true,
					permit: "hasDivisions"
				},
				{
					field: "purpose",
					title: "purpose",
					configId: "purpose",
					width: "300",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "fringe_benefit",
					title: "fringe_benefit",
					configId: "fringebenefit",
					width: "170",
					format: "boolean",
					className: "text-center",
					headerCell: "myBooleanHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "matriculation_date",
					title: "matriculation_date",
					configId: "matriculationDate",
					width: "250",
					headerCell: "myMatriculationDateHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "is_available",
					title: "available",
					configId: "available",
					width: "160",
					format: "boolean",
					className: "text-center",
					headerCell: "myBooleanHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "declared_co2_emission",
					title: "declared_co2_emission",
					configId: "declaredCo2Emission",
					width: "290",
					format: "numeric",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "average_consumption",
					title: "average_consumption",
					configId: "averageConsumption",
					width: "305",
					format: "numeric",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "gross_vehicle_mass",
					title: "gross_vehicle_mass",
					configId: "grossVehicleMass",
					width: "210",
					format: "numeric-int",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "power_kw",
					title: "power_kw",
					configId: "powerKw",
					width: "130",
					format: "numeric",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "displacement",
					title: "displacement",
					configId: "displacement",
					width: "130",
					format: "numeric",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "driving_license_type",
					title: "driving_license_type",
					configId: "drivingLicenseTypeName",
					width: "200",
					headerCell: "myLicenseTypesHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "battery_capacity",
					title: "battery_capacity",
					configId: "batteryCapacity",
					width: "150",
					format: "numeric",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: false
				},
				{
					field: "km_covered_recharge",
					title: "km_covered_recharge",
					configId: "kmCoveredRecharge",
					width: "150",
					format: "numeric",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: false
				},
				{
					field: "fuel_level_not_available",
					title: "fuel_level_not_available",
					configId: "fuelLevelNotAvailable",
					width: "150",
					format: "boolean",
					className: "text-center",
					headerCell: "myBooleanHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: false
				}
			],

			config: [],
			date: "12/07/2019",
			loading: false,
			items: [],
			canExportGridData: false,
			notHasGeolocationPermission: true,

			//table filters
			vehicles: [],
			drivers: [],
			// vehicleNameFilters: [],
			// vehicleNameFilterSelected: [],
			plateNumberFilters: [],
			plateNumberFilterSelected: [],
			codeFilters: [],
			codeFilterSelected: [],
			boxNumberFilters: [],
			boxNumberFilterSelected: [],
			groupsDataFilters: [],
			groupsDataFiltersSelected: [],
			fuelTypesFilters: [],
			fuelTypesFiltersSelected: [],
			secondaryFuelTypesFilters: [],
			secondaryFuelTypesFiltersSelected: [],
			driverNameSurnameFilters: [],
			driverNameSurnameFilterSelected: [],
			categoriesFilters: [],
			categoriesFiltersSelected: [],
			licenseTypesFilters: [],
			licenseTypesFiltersSelected: [],
			driverCFFilters: [],
			driverCFFilterSelected: [],
			ownershipTypesFilters: [],
			ownershipTypesFilterSelected: [],
			ownershipSuppliers: [],
			ownershipSuppliersFilterSelected: [],
			divisionsFilter: [],
			divisionsFilterSelected: [],

			hasDivisions: false
		};
	},
	created() {
		this.hasSelectedMode = true;
		this.hasEditableMode = true;

		if (this.vehicleIdFilterField == "code") {
			let col = this.columns.find(function(item) {
				return item.field == "number_plate";
			});
		
			if (col) col.filterable = false;
		}
		else {
			let col = this.columns.find(function(item) {
				return item.field == "vehicle_codes";
			});
		
			if (col) col.filterable = false;
		}

		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		if (this.vehicleIdFilterField == "code") this.vehicleIdFilterField = "vehicle_codes";

		if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
			this.query.pageSize = parseInt(this.settings.defaultPageSize);
		}

		if (this.settings && this.settings.canExportGridData) {
			this.canExportGridData = true;
		}

		if (this.settings && this.settings.hasDivisions) this.hasDivisions = true;

		if (this.scopes && this.scopes.length > 0) {
			this.notHasGeolocationPermission =
				this.scopes.some(item => {
					return item == "GEOLOCATION";
				}) == false;
		}

		this.getConfig();

		this.$nextTick(function() {
			this.getData();
		});

		this.getAllVehicles();
		this.getGroups();
		this.getFuelTypes();
		this.getAllDrivers();
		this.getCategories();
		this.getDrivingLicenseTypes();
		this.getOwnershipTypes();
		this.getOwnershipSuppliers();
		if (this.hasDivisions) this.getDivisions();
	},
	methods: {
		internalFiltersToUpdate(e) {
			if (e.field == "code") {
				this.codeFilterSelected = [];
			}
			if (e.field == "number_plate") {
				this.plateNumberFilterSelected = [];
			}
			// if (e.field == "brand") {
			// 	this.vehicleNameFilterSelected = [];
			// }
			if (e.field == "groups") {
				this.groupsDataFiltersSelected = [];
			}
			if (e.field == "driver_surname_name") {
				this.driverNameSurnameFilterSelected = [];
			}
			if (e.field == "driver_fiscal_code") {
				this.driverCFFilterSelected = [];
			}
			if (e.field == "fuel_type") {
				this.fuelTypesFiltersSelected = [];
			}
			if (e.field == "secondary_fuel_type") {
				this.secondaryFuelTypesFiltersSelected = [];
			}
			if (e.field == "ownership_type") {
				this.ownershipTypesFilterSelected = [];
			}
			if (e.field == "ownership_supplier") {
				this.ownershipSuppliersFilterSelected = [];
			}
			if (e.field == "division") {
				this.divisionsFilterSelected = [];
			}
			if (e.field == "category") {
				this.categoriesFiltersSelected = [];
			}
		},
		getDrivingLicenseTypes() {
			var self = this;
			api.getDrivingLicenseTypesData().then(res => {
				self.licenseTypesFilters = self._.sortBy(
					res.map(function(item) {
						return {
							id: item.id,
							value: item.name
						};
					}),
					function(item) {
						return item.value ? item.value.toLowerCase() : "";
					}
				);
			});
		},
		getOwnershipTypes() {
			var self = this;
			api.getOwnershipTypes().then(res => {
				self.ownershipTypesFilters = self._.sortBy(
					res.map(function(item) {
						return {
							id: item.id,
							value: item.name
						};
					}),
					function(item) {
						return item.value ? item.value.toLowerCase() : "";
					}
				);
			});
		},
		getOwnershipSuppliers() {
			var self = this;
			api.getOwnershipSuppliers().then(res => {
				self.ownershipSuppliers = self._.sortBy(
					res.map(function(item) {
						return {
							id: item.id,
							value: item.name.toLowerCase()
						};
					}),
					function(item) {
						return item.value;
					}
				);
			});
		},
		getDivisions() {
			var self = this;
			api.getDivisionsData().then(res => {
				self.divisionsFilter = self._.sortBy(
					res
						.filter(function(dv) {
							return dv.name.length > 0;
						})
						.map(function(item) {
							return {
								id: item.id,
								value: item.name.toLowerCase()
							};
						}),
					function(dv) {
						return dv.value;
					}
				);
			});
		},
		getCategories() {
			var self = this;
			api.getCategoriesData().then(res => {
				self.categoriesFilters = self._.sortBy(
					res.map(function(item) {
						return {
							id: item.id,
							value: `${item.name}${item.description ? " - " + item.description : ""}`
						};
					}),
					function(item) {
						return item.value ? item.value.toLowerCase() : "";
					}
				);
			});
		},
		getAllDrivers() {
			var self = this;
			api.getDriversData({ page: 0, pageSize: 1000000 }).then(res => {
				self.drivers = res.items.map(function(driver) {
					return {
						id: driver.id,
						name: driver.name,
						surname: driver.surname,
						name_surname_fiscalcode: `${driver.name} ${driver.surname} ${driver.fiscal_code}`,
						fiscal_code: driver.fiscal_code
					};
				});

				self.drivers = self._.sortBy(self.drivers, ["surname", "name"]);

				for (var i = 0; i < self.drivers.length; i++) {
					var driver = self.drivers[i];

					var alreadyExist =
						self.driverNameSurnameFilters.findIndex(item => {
							return item.id == `${driver.surname.toLowerCase()} ${driver.name.toLowerCase()}`;
						}) >= 0;
					if (!alreadyExist) {
						self.driverNameSurnameFilters.push({
							id: `${driver.surname.toLowerCase()} ${driver.name.toLowerCase()}`,
							value: `${driver.surname} ${driver.name}`
						});
					}

					if (driver.fiscal_code) {
						var alreadyExist =
							self.driverCFFilters.findIndex(item => {
								return item.id == driver.fiscal_code.toLowerCase();
							}) >= 0;
						if (!alreadyExist) {
							self.driverCFFilters.push({
								id: driver.fiscal_code.toLowerCase(),
								value: driver.fiscal_code.toLowerCase()
							});
						}
					}
				}

				self.driverNameSurnameFilters = self._.sortBy(self.driverNameSurnameFilters, function(item) {
					return item.id;
				});

				self.driverCFFilters = self._.sortBy(self.driverCFFilters, function(item) {
					return item.id;
				});
			});
		},
		getFuelTypes: function() {
			var self = this;
			api.getFuelTypesData().then(res => {
				self.fuelTypesFilters = self._.sortBy(
					res.map(function(item) {
						return {
							id: item.id,
							value: item.name
						};
					}),
					function(item) {
						return item.value ? item.value.toLowerCase() : "";
					}
				);
				self.secondaryFuelTypesFilters = JSON.parse(JSON.stringify(self.fuelTypesFilters));
			});
		},
		getGroups: function() {
			var self = this;
			api.getGroupsData().then(res => {
				self.groupsDataFilters = self._.sortBy(
					res.map(function(item) {
						return {
							id: item.id,
							value: item.name
						};
					}),
					function(item) {
						return item.value ? item.value.toLowerCase() : "";
					}
				);
			});
		},
		getAllVehicles: function() {
			var self = this;
			api.getVehiclesLookup({ page: 0, pageSize: 1000000 }).then(res => {
				self.vehicles = res.items.map(function(vehicle) {
					return {
						id: vehicle.id,
						name: vehicle.name,
						number_plate: vehicle.number_plate,
						name_numberplate: `${vehicle.number_plate} ${vehicle.name}`,
						code: vehicle.code ? vehicle.code.toLowerCase() : ""
					};
				});

				for (var i = 0; i < self.vehicles.length; i++) {
					var vehicle = self.vehicles[i];
					// if (vehicle.name) {
					// 	var alreadyExist =
					// 		self.vehicleNameFilters.findIndex(item => {
					// 			return item.id == vehicle.name.toLowerCase();
					// 		}) >= 0;
					// 	if (!alreadyExist) {
					// 		self.vehicleNameFilters.push({
					// 			id: vehicle.name.toLowerCase(),
					// 			value: vehicle.name.toLowerCase()
					// 		});
					// 	}
					// }

					if (vehicle.number_plate) {
						var alreadyExist =
							self.plateNumberFilters.findIndex(item => {
								return item.id == vehicle.number_plate;
							}) >= 0;
						if (!alreadyExist) {
							self.plateNumberFilters.push({
								id: vehicle.number_plate,
								value: vehicle.number_plate
							});
						}
					}

					if (vehicle.code) {
						var alreadyExist =
							self.codeFilters.findIndex(item => {
								return item.id == vehicle.code;
							}) >= 0;
						if (!alreadyExist) {
							self.codeFilters.push({
								id: vehicle.code,
								value: vehicle.code
							});
						}
					}

					self.plateNumberFilters = self._.sortBy(self.plateNumberFilters, ["value"]);
					self.codeFilters = self._.sortBy(self.codeFilters, ["value"]);
				}
			});
		},
		saveData: function() {
			var self = this;
			//to do
		},
		getConfig: function() {
			var self = this;
			api.getViewConfig("fleerun_vehicles").then(res => {
				self.config = res;

				if (self.config && self.config.length > 0) {
					var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

					orderedConfigColumn.forEach(column => {
						var defColumn = self.columns.find(function(f) {
							return f.configId === column.field;
						});

						if (defColumn && column.enabled && (!defColumn.permit || self[defColumn.permit])) {
							if (column.label && column.label.toLowerCase().indexOf("co2") >= 0) {
								column.label = column.label.toLowerCase().replace("co2", "co<sub>2</sub>");
							}
							defColumn.title = column.label;

							self.columnsToShow.push(defColumn);
						}
					});

					if (self.columnsToShow.length > 0) {
						var columnsByPassConfig = self._.filter(self.columns, function(item) {
							return item.configByPass;
						});

						for (var i = 0; i < columnsByPassConfig.length; i++) {
							//self.columnsToShow.push(columnsByPassConfig[i]);
							var index = columnsByPassConfig[i].order || 0;
							self.columnsToShow.splice(index, 0, columnsByPassConfig[i]);
						}
					}

					self.dataReady = true;
				}
			});
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.getData();
		},
		filterChange: function(ev) {
			this.filter = ev.filter;
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			this.getData();
		},
		groupsToString(groups) {
			if (this._.isNull(groups) === false && this._.isUndefined(groups) === false && this._.isArray(groups) && groups.length > 0) {
				var str = "";
				groups = this._.sortBy(groups, function(gr) {
					return gr.value ? gr.value.toLowerCase() : "";
				});
				groups.forEach(element => {
					str += element.value + ", ";
				});

				str = str.replace(/, $/, "");
				return str;
			}

			return "";
		},
		getData: function() {
			var self = this;
			this.loading = true;

			var data = this._.clone(this.query);

			//because field and filter is different
			if (data.sort.indexOf("vehicle_codes") >= 0) {
				data.sort = data.sort.replace("vehicle_codes", "code");
			}

			if (this.columnFilters) {
				for (var i = 0; i < this.columnFilters.length; i++) {
					var clmF = this.columnFilters[i];

					for (var j = 0; j < clmF.filter.filters.length; j++) {
						var filt = clmF.filter.filters[j];
						var field = filt.field;
						var value = filt.value;

						data[field] = value;
					}
				}
			}

			api.getVehiclesData(data).then(res => {
				self.loading = false;

				self.items = res.items.map(function(item) {
					var row = {};
					self.columns.forEach(function(c) {
						if (c.configId === "vehicleBrandModel") {
							row[c.field] = `${item.brand ? item.brand.value + " - " : ""}${item.name}`;
						} else if (c.configId === "ownershipTypeName") {
							row[c.field] = item.ownership_type ? item.ownership_type.value : "";
						} else if (c.configId === "ownershipSupplierName") {
							row[c.field] = item.ownership_supplier ? item.ownership_supplier.value : "";
						} else if (c.configId === "groups") {
							row[c.field] = self.groupsToString(item.groups);
						} else if (c.configId === "driverSurnameName") {
							row[c.field] = item.driver_name ? `${item.driver_surname} ${item.driver_name}` : item.driver_surname;
						} else if (c.configId === "fuelTypeName") {
							row[c.field] = item.fuel_type ? item.fuel_type.value : "";
						} else if (c.configId === "secondaryFuelTypeName") {
							row[c.field] = item.secondary_fuel_type ? item.secondary_fuel_type.value : "";
						} else if (c.configId === "categoryName") {
							row[c.field] = item.category ? item.category.value : "";
						} else if (c.configId === "divisionName") {
							row[c.field] = item.division ? item.division.value : "";
						} else if (c.configId === "drivingLicenseTypeName") {
							row[c.field] = item.driving_license_type ? item.driving_license_type.value : "";
						} else if (c.configId === "matriculationDate") {
							row[c.field] = self.$options.filters.dateToString(item.matriculation_date);
						} else if (c.configId === "code") {
							row[c.field] = item.code ? item.code : "";
						} else {
							row[c.field] = item[c.field];
						}
					});

					row.box_end_date = item.box_end_date;

					return row;
				});

				self.total = res.totalCount;
			});
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},

		downloadXlsx(type) {
			var self = this;
			if (type == "csv") this.query["format"] = "csv";
			api.exportXlsx("vehicles", this.query).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Veicoli.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		goTo(dataItem) {
			var id = dataItem.id;

			this.$router.push({
				name: "VEHICLE_DETAIL",
				params: {
					id: id
				}
			});
		},
		goToLocalizazion(number_plate, box_end_date, vehicleId) {
			if (this.notHasGeolocationPermission == false && this.isBoxDeactivated(box_end_date) == false) {
				this.$router.push({
					name: "GEOLOCATION",
					query: {
						vehicleId: number_plate
					}
				});
			}
		},
		isBoxDeactivated(boxEndDate) {
			if (!boxEndDate) return false;

			var now = moment();
			var endDate = moment.utc(boxEndDate).tz("Europe/Rome");

			return endDate < now;
		}
	},

	computed: {
		result: {
			get: function() {
				var self = this;

				var orderedResult = orderBy(self.items, this.sort);
				//var filteredResult = filterBy(orderedResult, this.filter);
				return orderedResult;
			}
		},
		...mapGetters(["settings", "scopes"])
	}
};
